import { MouseEvent } from "react";

import { IconButton, Tooltip } from "@mui/material";
import { IoClose } from "react-icons/io5";

import { TLocalCourseDocument } from "../../hooks/useMyCourseInstructor";

export type TCourseDocumentVideoProps = {
	file: TLocalCourseDocument;
	onRemoveFile: (id: string) => void;
};

export function LocalCourseDocumentVideo({
	file,
	onRemoveFile,
}: TCourseDocumentVideoProps) {
	const onClickRemoveFile = (
		e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
	) => {
		e.stopPropagation();
		if (file.id) {
			onRemoveFile(file.id);
		}
	};

	return (
		<div className="media-container">
			<video className="media" playsInline>
				<source src={file.data} type="video/mp4" />
			</video>
			<Tooltip title="Remove">
				<IconButton className="remove-button" onClick={onClickRemoveFile}>
					<IoClose />
				</IconButton>
			</Tooltip>
		</div>
	);
}
